import React, { useCallback } from 'react';
import { Config } from '@leverege/plugin';
import { UI } from '@leverege/ui-redux';
import { connect } from 'react-redux';
import { Button, Pane, Text } from '@leverege/ui-elements';
import MoltenUtil from "../../MoltenUtil.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ReleaseAvailableOverlay(props) {
  const {
    pendingRelease,
    pendingReleaseDismissed
  } = props;
  const {
    position,
    top,
    bottom,
    left,
    right
  } = Config.get('ReleaseAvailableOverlay', 'position', {
    position: 'absolute',
    bottom: 10,
    left: 10
  });
  const onUpgradeClick = useCallback(async () => {
    await MoltenUtil.handleHardReload();
  }, []);
  if (!pendingRelease || pendingReleaseDismissed) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "releaseAvailableOverlay",
    style: {
      position,
      top,
      bottom,
      left,
      right,
      zIndex: 9999
    },
    layout: "flex:rowMCenter",
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "releaseAvailable|body",
      children: "New Release Available!"
    }), /*#__PURE__*/_jsx(Button, {
      variant: "secondarySmall",
      onClick: onUpgradeClick,
      children: "Upgrade Now"
    })]
  });
}
export default connect(state => {
  return {
    pendingRelease: UI.get(state, 'pendingRelease')
  };
})(ReleaseAvailableOverlay);